import { CSSProperties, useEffect, useState } from 'react';
import { useListingRequestContext } from '@vivli/features/listing-request/infrastructure/context';
import { TabComponent, TabsComponent } from '@vivli/shared/components';
import { NotificationFeature } from '@vivli/shared/features/notification/feature';
import { Size } from '@vivli/shared/theme';
import { useNotificationContext } from '@vivli/shared/features/notification/infrastructure/context';
import { useActiveUserContext } from '@vivli/core/infrastructure/context';
import { ListingRequestStatusUpdateForm } from '../listing-request-status-update.form';
import { useFormContext, useFormState } from 'react-hook-form';
import { IListingRequest } from '@vivli/features/listing-request/infrastructure/interface';
import { NotificationTopicEnum } from '@vivli/shared/features/notification/infrastructure/enum';
import { ButtonView } from '@vivli/shared/views';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';

const containerStyle: CSSProperties = {
    margin: ` ${Size.INSET_SIZE}px`,
    height: '100%'
};

const buttonContainerStyle: CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '15px'
};

const tabButtonsStyle: CSSProperties = {
    display: 'flex',
    gap: '10px',
    height: '100%',
    position: 'absolute',
    right: '30px'
};

interface IStatusUpdateTab {
    name: string;
    sortOrder: number;
    title: string;
}

enum TabTitleEnum {
    statusUpdate = 'Status Update',
    notification = 'Notifications'
}

enum TabRouteEnum {
    statusUpdate = 'Status Update',
    notification = 'Notifications'
}

export const ListingStatusUpdateComponent = () => {
    const { listingRequest, handleFormSave, isLoading } = useListingRequestContext();
    const { resetNotificationForm, handleSubmit, notifications, isSaving } = useNotificationContext();
    const { isValid } = useFormState();

    const { hasPermission } = useActiveUserContext();
    const [tabs, setTabs] = useState<IStatusUpdateTab[]>();
    const [activeTab, setActiveTab] = useState('');
    const formApi = useFormContext<IListingRequest>();

    const getTabs = () => {
        const defaultTabs: IStatusUpdateTab[] = [
            {
                name: TabRouteEnum.statusUpdate,
                sortOrder: 0,
                title: TabTitleEnum.statusUpdate
            },
            {
                name: TabRouteEnum.notification,
                sortOrder: 1,
                title: TabTitleEnum.notification
            }
        ];
        return defaultTabs.sort((a, b) => a.sortOrder - b.sortOrder);
    };

    useEffect(() => {
        //TODO PERMFE - redo with permissions+
        if (hasPermission(PermissionsEnum.SubmissionsActAdv)) {
            setTabs(getTabs());
        } else {
            setTabs([getTabs()[0]]);
        }
    }, []);

    useEffect(() => {
        if (tabs !== undefined) setActiveTab(tabs[0].name);
    }, [tabs]);

    const buttonsDisplayed = (activeTab) => {
        switch (activeTab) {
            case 'Status Update':
                return (
                    <>
                        <div style={buttonContainerStyle}>
                            <ButtonView
                                style={{ maxWidth: '200px' }}
                                isLoading={isLoading}
                                disabled={isLoading}
                                onClick={() => handleFormSave(false)}
                            >
                                {'Save Status Update'}
                            </ButtonView>
                        </div>
                    </>
                );
            case 'Notifications':
                return (
                    <>
                        <div style={buttonContainerStyle}>
                            {notifications[0] && (
                                <ButtonView style={{ maxWidth: '200px' }} onClick={resetNotificationForm}>
                                    {'Create New Notification'}
                                </ButtonView>
                            )}
                            <ButtonView
                                style={{ maxWidth: '200px' }}
                                disabled={!isValid}
                                isLoading={isSaving}
                                onClick={() => handleSubmit(NotificationTopicEnum.ListingRequest)}
                            >
                                {'Save Notification'}
                            </ButtonView>
                        </div>
                    </>
                );
            default:
                return null;
        }
    };
    const handleTabClick = (tab: IStatusUpdateTab) => {
        setActiveTab(tab.name);
    };

    const tabDisplayed = (activeTab) => {
        switch (activeTab) {
            case 'Status Update':
                return (
                    <div>
                        <ListingRequestStatusUpdateForm />
                    </div>
                );
            case 'Notifications':
                return <NotificationFeature topicId={listingRequest.id} />;
            default:
                return null;
        }
    };

    return (
        <div style={containerStyle}>
            <div style={containerStyle}>
                <TabsComponent defaultTab={0}>
                    {tabs?.map((tab, i) => {
                        const { title } = tab;
                        return (
                            <TabComponent
                                key={i}
                                title={title}
                                onTabClick={() => handleTabClick(tab)}
                                rightHeaderContent={<div style={tabButtonsStyle}>{buttonsDisplayed(activeTab)}</div>}
                            >
                                {tabDisplayed(activeTab)}
                            </TabComponent>
                        );
                    })}
                </TabsComponent>
            </div>
        </div>
    );
};
